import React, { memo, type ReactNode } from 'react';

import clsx from 'clsx';

import { ReactComponent as CheckmarkIcon } from '@/assets/images/checkmark.svg?react';

import s from './CheckmarkButton.module.scss';

interface Props {
  children: ReactNode;
  isChecked?: boolean;
  onClick: () => void;
}

const Component: React.FC<Props> = ({ children, isChecked = false, onClick }) => {
  return (
    <>
      <button
        className={clsx(s.btn, { [s.checked]: isChecked })}
        onClick={isChecked ? undefined : onClick}
      >
        {children}
        {isChecked && (
          <div className={s.icon}>
            <CheckmarkIcon className={s.checkmark} />
          </div>
        )}
      </button>
    </>
  );
};

export const CheckmarkButton = memo(Component);
